// Placeholder for routes whose full pages land in later CLs (Projects, Artifacts, Skills, Settings).
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { SERIF_HEADING } from '../theme'

export function PlaceholderPage({ title }: { title: string }) {
  return (
    <Box sx={{ maxWidth: 960, mx: 'auto', px: 4, py: 6 }}>
      <Typography variant="h3" sx={SERIF_HEADING}>{title}</Typography>
      <Typography sx={{ color: 'text.secondary', mt: 1 }}>Coming soon.</Typography>
    </Box>
  )
}
